document.addEventListener("DOMContentLoaded", function () {
  // Prevent script from running in Shopify's theme editor
  if (window.Shopify && Shopify.designMode) return;
  
  let widgetMoved = false;

  function moveWiBogoWidget() {
    const widget = document.querySelector('.wizz-widget');
    const addToCartBlock = document.querySelector('.product__block--buy_buttons');

    if (widget && addToCartBlock && !widgetMoved) {
      // Move the widget below the Add to Cart block
      addToCartBlock.insertAdjacentElement('afterend', widget);

      widgetMoved = true;
      observer.disconnect(); // Stop watching once done
    }
  }

  // Attempt to move immediately
  moveWiBogoWidget();

  // Watch DOM in case widget loads late
  const observer = new MutationObserver(() => {
    moveWiBogoWidget();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});